import React from "react";
import ExcelJS from "exceljs";
import { parseCustomDate } from "./ExcelVettingReport";

const ExcelQueryMailSubReport = ({ data }) => {
  const exportExcelFile = async () => {
    if (!Array.isArray(data)) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    worksheet.columns = [
      { header: "S.No", key: "serial", width: 10 },
      { header: "File Name", key: "file_name", width: 20 },
      { header: "Loan Type", key: "loan_type", width: 20 },
      { header: "LH Branch Name", key: "lh_branch_name", width: 24 },
      { header: "Bank Name", key: "bank_name", width: 24 },
      { header: "Product Name", key: "product_name", width: 24 },
      { header: "Bank Branch Name", key: "bank_branch_name", width: 24 },
      { header: "Borrower Name", key: "borrower_name", width: 24 },
      { header: "Owner Name", key: "owner_name", width: 24 },
      { header: "App ID", key: "app_id", width: 20 },
      { header: "File Status", key: "file_status", width: 18 },
      { header: "Login Date", key: "login_date", width: 20 },
      { header: "Updated Date", key: "updated_dt", width: 20 },
      { header: "Prosses Officer", key: "prosses_officer", width: 24 },
      { header: "Query Received Via Mail Date", key: "query_received_via_mail_date", width: 28 },
      { header: "Query Uploaded by", key: "query_uploaded_by", width: 24 },
      { header: "Query Uploaded Date & Time", key: "query_uploaded_dt", width: 28 },
      { header: "Query Received Documents Details", key: "query_received_documents_details", width: 40 },
      { header: "Pending Query Details", key: "pending_query_details", width: 30 },
      { header: "Query Raised Date & Time", key: "query_raised_dt", width: 28 },
      { header: "Query Mail Closing Reason", key: "query_mail_closing_reason", width: 40 },
    ];

    worksheet.getRow(1).eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFF00" } };
      cell.font = { bold: true, size: 12 };
    });

    data.forEach((item, index) => {
      const closingReason =
        item.query_mail_closing_reason != null && String(item.query_mail_closing_reason).trim() !== ""
          ? String(item.query_mail_closing_reason).trim()
          : "";
      const pendingQueryDetails =
        item.pending_query_details != null && String(item.pending_query_details).trim() !== ""
          ? String(item.pending_query_details).trim()
          : "";

      const row = worksheet.addRow({
        serial: index + 1,
        ...item,
        login_date: item.login_date ? parseCustomDate(item.login_date) : "",
        updated_dt: item.updated_dt ? parseCustomDate(item.updated_dt) : "",
        query_received_via_mail_date: item.query_received_via_mail_date ? parseCustomDate(item.query_received_via_mail_date) : "",
        query_uploaded_dt: item.query_uploaded_dt ? parseCustomDate(item.query_uploaded_dt) : "",
        query_raised_dt: item.query_raised_dt ? parseCustomDate(item.query_raised_dt) : "",
        pending_query_details: pendingQueryDetails,
        query_mail_closing_reason: closingReason,
      });

      row.eachCell((cell, colNumber) => {
        cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        if (colNumber === 19) {
          cell.alignment = { vertical: "top", horizontal: "left", wrapText: true };
        }
        if ([12, 13, 15, 17, 20].includes(colNumber)) {
          cell.numFmt = "dd-mm-yyyy hh:mm:ss";
        }
      });
    });

    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate().toString().padStart(2, "0")}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${currentDate.getFullYear()}`;
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = `Query-Mail-Subreport ${formattedDate}.xlsx`;
    anchor.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <button className="excel-download-btn" onClick={exportExcelFile}>
      Download as Excel
    </button>
  );
};

export default ExcelQueryMailSubReport;
